import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { BladeCal } from '@/constants/blade';

export default function Step2({ callBack, calObj }: any) {
    const { useState, useLang, gtm } = useGlobal();
    const { t } = useLang('bladecalculator');
    const [checked, setChecked] = useState(calObj?.check3 || []);
    const OBJ_KIND_ARR: any = [
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step3_1.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step3_1.png')}
                    alt={t('detail.calculator_step3_text1')}
                    aria-label={t('detail.calculator_step3_text1')}
                />
            ),
            text: t('detail.calculator_step3_text1'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step3_2.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step3_2.png')}
                    alt={t('detail.calculator_step3_text2')}
                    aria-label={t('detail.calculator_step3_text2')}
                />
            ),
            text: t('detail.calculator_step3_text2'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step3_3.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step3_3.png')}
                    alt={t('detail.calculator_step3_text3')}
                    aria-label={t('detail.calculator_step3_text3')}
                />
            ),
            text: t('detail.calculator_step3_text3'),
        },
    ];
    const handleCheck = (n: number) => {
        let arr = [];
        if (checked.includes(n + 1)) {
            const checkedArr = n === OBJ_KIND_ARR?.length - 1 ? [] : checked?.filter((item: number) => item !== n + 1);
            arr = checkedArr || [];
            setChecked(checkedArr);
        } else {
            if (n === OBJ_KIND_ARR?.length - 1) {
                setChecked([n + 1]);
                arr = [n + 1];
            } else {
                if (checked?.includes(OBJ_KIND_ARR?.length)) {
                    const tempArr = [...checked?.filter((item: number) => item !== OBJ_KIND_ARR?.length), n + 1];
                    setChecked(tempArr);
                    arr = tempArr;
                } else {
                    setChecked([...checked, n + 1]);
                    arr = [...checked, n + 1];
                }
            }
        }
        callBack({
            ...calObj,
            currentStep: arr?.length > 0 ? 3 : 2,
            check3: arr,
        });
    };
    const handleNext = () => {
        callBack({ ...calObj, currentPage: BladeCal.Step4 });
        const option = checked.map((item: any) => OBJ_KIND_ARR[item - 1]?.text);
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process3',
            step: 'Lawn type',
            product_name: 'EcoFlow BLADE',
            button_name: 'Next',
            option_name: option.sort().join('_'),
        });
    };
    const handleBack = () => {
        callBack({ ...calObj, currentPage: BladeCal.Step2, currentStep: 2, check3: undefined });
    };
    return (
        <div className={`step3 ${css.step3}`}>
            <p className="step3-title">{t('detail.calculator_step3_title')}</p>
            <ul className="step3-box">
                {OBJ_KIND_ARR?.map((kind: any, k: number) => (
                    <li className="step3-item" key={kind?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            {kind?.img}
                            {checked.includes(k + 1) && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{kind?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="step3-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('detail.calculator_btn_back')}
                </button>
                <button className="btn-next" disabled={checked?.length === 0} onClick={handleNext}>
                    {t('detail.calculator_btn_next')}
                </button>
            </div>
        </div>
    );
}
